import React, { FC } from 'react';
import { FlattenSimpleInterpolation } from 'styled-components';

import { useWebp } from '@r1-frontend/shared/hooks/useWebp';

import * as ST from './styled';

export type TArea = 'second' | 'first' | 'third' | 'large';

export type TStyles = string | FlattenSimpleInterpolation;

export interface IContentCardItem {
    title: string,
    description?: string,
    img: string,
    imgWebp?: string,
    bigImg?: string,
    area: TArea,
    imageStyles?: TStyles,
    containerStyles?: TStyles,
    titleStyles?: TStyles,
}

interface IProps {
    item: IContentCardItem,
    isShowBigImg?: boolean,
    withoutDisplayColumn?: boolean,
}

const ContentCard: FC<IProps> = ({
    isShowBigImg,
    item: {
        area,
        bigImg,
        description,
        img,
        imgWebp,
        title,
        imageStyles,
        containerStyles,
        titleStyles,
    },
    withoutDisplayColumn,
}) => {

    const src = useWebp() && imgWebp ? imgWebp : img;

    return (
        <ST.Block
            area={area}
            key={title}
            withoutDisplayColumn={withoutDisplayColumn}
            styles={containerStyles}
        >
            <ST.TextBlock>
                <ST.Title styles={titleStyles}>{title}</ST.Title>
                {description && <ST.Description>{description}</ST.Description>}
            </ST.TextBlock>
            <ST.ImageBlock area={area} styles={imageStyles}>
                <ST.Image src={isShowBigImg && bigImg ? bigImg : src} alt={img}/>
            </ST.ImageBlock>
        </ST.Block>
    );
};

export default ContentCard;
